module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAQAAABjX+2PAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkDAwQIDKPUnffAAAAaElEQVQYlWNgYGDYzqDFgAf8Z/jNMJVBBLc0CL5nyGVgwS0NglcZPPBJgyCGS/6jQTSXoEtDXFLMwIZbGgRvM3jhk4Y6FJvUa4YsmDfRpX4y9DAI4PaYKhnBgmQbujSabahgHYMKLikAjidvfTWAl50AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMTItMTJUMTY6MzI6NTArMDA6MDD1VDOWAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTEyLTEyVDE2OjMyOjUwKzAwOjAwhAmLKgAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/intelligent/school_triangle.png
// module id = 810
// module chunks = 0